import { render, staticRenderFns } from "./PaginationApp.vue?vue&type=template&id=36961dd3&scoped=true"
import script from "./PaginationApp.vue?vue&type=script&lang=js"
export * from "./PaginationApp.vue?vue&type=script&lang=js"
import style0 from "./PaginationApp.vue?vue&type=style&index=0&id=36961dd3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36961dd3",
  null
  
)

export default component.exports